// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g_D4","block":"styles_block__BxaWW","slide0":"styles_slide0__2oBQF","header":"styles_header__h9zwr"};